module.exports = __webpack_public_path__ + "static/media/hidden-picture.ffaaa31d.png";